var map = {
	"./Aztecs.png": "94e9",
	"./Bengalis.png": "d578",
	"./Berbers.png": "9b8c",
	"./Bohemians.png": "bcdd",
	"./Britons.png": "33db",
	"./Bulgarians.png": "788f",
	"./Burgundians.png": "29dc",
	"./Burmese.png": "d283",
	"./Byzantines.png": "0201",
	"./Celts.png": "97c4",
	"./Chinese.png": "cfeb",
	"./Cumans.png": "923e",
	"./Dravidians.png": "90e0",
	"./Escudos_Civilizaciones_Aoe2.png": "995d",
	"./Ethiopians.png": "2a6c",
	"./Franks.png": "2bc1",
	"./Goths.png": "2467",
	"./Gurjaras.png": "b297",
	"./Huns.png": "5a38",
	"./Incas.png": "e6d5",
	"./Indians.png": "9086",
	"./Italians.png": "84dc",
	"./Japanese.png": "b2fa",
	"./Khmer.png": "5e01",
	"./Koreans.png": "15e1",
	"./Lithuanians.png": "ba27",
	"./Magyars.png": "db20",
	"./Malay.png": "b1e7",
	"./Malians.png": "df50",
	"./Mayans.png": "190f",
	"./Mongols.png": "2e39",
	"./Persians.png": "0773",
	"./Poles.png": "a8d8",
	"./Portuguese.png": "0cdd",
	"./Saracens.png": "0ca2",
	"./Sicilians.png": "e607",
	"./Slavs.png": "1a72",
	"./Spanish.png": "3aa0",
	"./Tatars.png": "02d5",
	"./Teutons.png": "cc01",
	"./Turks.png": "2aa9",
	"./Vietnamese.png": "f3c6",
	"./Vikings.png": "28d7",
	"./aztecs-DE.png": "8e76",
	"./bengalis-DE.png": "383b",
	"./berbers-DE.png": "1e1b",
	"./bohemians-DE.png": "be4e",
	"./britons-DE.png": "802a",
	"./bulgarians-DE.png": "77d5",
	"./burgundians-DE.png": "b696",
	"./burmese-DE.png": "c63d",
	"./byzantines-DE.png": "ae81",
	"./celts-DE.png": "c5a8",
	"./chinese-DE.png": "5507",
	"./cumans-DE.png": "7ecb",
	"./dravidians-DE.png": "0aac",
	"./error.png": "1fe8",
	"./ethiopians-DE.png": "6011",
	"./franks-DE.png": "418b",
	"./ganador.png": "f2e7",
	"./goths-DE.png": "db1f",
	"./gurjaras-DE.png": "2d5d",
	"./hex.png": "c06d",
	"./huns-DE.png": "a735",
	"./incas-DE.png": "e62a",
	"./indians-DE.png": "e07b",
	"./italians-DE.png": "e8db",
	"./japanese-DE.png": "d417",
	"./khmer-DE.png": "da13",
	"./koreans-DE.png": "6037",
	"./lithuanians-DE.png": "8988",
	"./logo.png": "cf05",
	"./magyars-DE.png": "d437",
	"./malay-DE.png": "6fd8",
	"./malians-DE.png": "5e1c",
	"./mayans-DE.png": "8a23",
	"./mongols-DE.png": "26f1",
	"./nodata.png": "4099",
	"./persians-DE.png": "077e",
	"./poles-DE.png": "ba84",
	"./portuguese-DE.png": "c8ad",
	"./saracens-DE.png": "5274",
	"./sicilians-DE.png": "1806",
	"./slavs-DE.png": "2f59",
	"./spanish-DE.png": "1943",
	"./swords.png": "e28d",
	"./tatars-DE.png": "9db2",
	"./teutons-DE.png": "9132",
	"./turks-DE.png": "6304",
	"./vietnamese-DE.png": "6184",
	"./vikings-DE.png": "ec5a",
	"./wallpaper.png": "c91e"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "9e01";